import { CloseOutlined } from '@ant-design/icons'
import { ClipboardButton, LinkButton, Popover, useACTheme } from 'admin-web-ui'
import React, { ReactNode, useState } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { VirtualCard } from '../../types'
import { TableCell } from '../components/TableCell'

const StyledLinkButton = styled(LinkButton)`
  color: ${({ theme }) => theme.colors.sudoBlue};
`

const StyledDetailsTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
  padding-top: 15px;
`

interface Props {
  card: VirtualCard
  cardDisplayName: string
  username: string
}

export const VirtualCardsListItem: React.FC<Props> = ({
  card,
  cardDisplayName,
  username,
}) => {
  const theme = useACTheme()
  const [popoverOpen, setPopoverOpen] = useState(false)
  const isCancelled = !!card.cancelledAt ? 'true' : 'false'
  const externalId = username ?? ''
  const linkTo = `../virtual-cards/transaction-search?externalId=${externalId}&last4=${card.last4}`

  return (
    <tr key={card.id}>
      <TableCell>{cardDisplayName}</TableCell>
      <TableCell>{card.state}</TableCell>
      <TableCell>
        <Link to={linkTo} target="_blank" rel="noreferrer">
          {card.last4}
        </Link>
      </TableCell>
      <TableCell>{isCancelled}</TableCell>
      <TableCell>
        <Popover
          title={
            <StyledDetailsTitle>
              <h4>{`${cardDisplayName} Details`}</h4>
              <CloseOutlined onClick={() => setPopoverOpen(false)} />
            </StyledDetailsTitle>
          }
          content={displayCardDetails(card)}
          trigger="click"
          showArrow={false}
          placement="leftTop"
          open={popoverOpen}
          onOpenChange={setPopoverOpen}
          overlayInnerStyle={{ backgroundColor: theme.greys.solitude }}
        >
          <StyledLinkButton>Details</StyledLinkButton>
        </Popover>
      </TableCell>
    </tr>
  )
}

const StyledDisplayCardRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
  gap: 20px;
`

const displayCardDetails = (card: VirtualCard): ReactNode => (
  <>
    {displayRow('Created At', card.createdAt.toUTCString())}
    {displayRow('Updated At', card.updatedAt.toUTCString())}
    {displayRow('Cancelled At', card.cancelledAt?.toUTCString() ?? '-')}
    {displayRow('Key ID', card.keyId)}
    {displayRow('Key Ring ID', card.keyRingId)}
    {displayRow('Owners', JSON.stringify(card.owners.map((owner) => owner.id)))}
  </>
)

const displayRow = (label: string, value: string): ReactNode => (
  <StyledDisplayCardRow>
    <p>{`${label}: ${value}`}</p>
    <ClipboardButton copyText={value} buttonText="Copy" />
  </StyledDisplayCardRow>
)
